import LockIcon from '../CustomIcons/LockIcon'
import { cn } from '../utlis/cn'
import { useIsProUser } from '../services/useIsProUser'
import { UpgradeToMuseProDialogType } from '@/AppContext'
import { useTranslation } from 'react-i18next'
import { useUnlockProHandler } from './useUnlockProHandler'

type UnlockWithProProps = {
    className?: string
    reason?: UpgradeToMuseProDialogType
}
export function UnlockWithPro({ className, reason }: UnlockWithProProps) {
    const { t } = useTranslation()
    const isProUser = useIsProUser()
    const handleProUpgrade = useUnlockProHandler()

    if (isProUser) {
        return null
    }

    return (
        <div
            onClick={() => handleProUpgrade(reason)}
            className={cn(
                'flex items-center gap-2 cursor-pointer t-base-light leading-[20px] text-[#FCDD40]',
                className
            )}
        >
            <LockIcon style={{ fontSize: '1.3rem' }} />
            <span>{t('Unlock with Pro')}</span>
        </div>
    )
}
